// src/utils/checkCache.js
export async function checkServiceWorkerCache() {
	if (!("serviceWorker" in navigator)) {
		console.log("Service Worker not supported");
		return;
	}

	const registration = await navigator.serviceWorker.ready;

	if (!registration.active) {
		console.log("No active Service Worker");
		return;
	}

	// Get cache info
	const messageChannel = new MessageChannel();

	return new Promise((resolve) => {
		messageChannel.port1.onmessage = (event) => {
			console.log("📦 Service Worker Caches:", event.data);
			event.data.forEach((cache) => {
				console.log(`\n${cache.cacheName}:`);
				cache.urls.forEach((url) => console.log(`  - ${url}`));
			});
			resolve(event.data);
		};

		registration.active.postMessage("getCacheInfo", [messageChannel.port2]);
	});
}
